import { useState } from 'react';
import { useCustom } from '@refinedev/core';
import { Card, Segmented } from 'antd';
import { Area } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { DailyCountOut } from '@/api/generated/schemas';

const PERIODS = [
  { label: '7 dni', value: 7 },
  { label: '30 dni', value: 30 },
  { label: '90 dni', value: 90 },
];

const REGISTRATIONS_LABEL = 'Rejestracje';
const DELETIONS_LABEL = 'Usunięcia';

export const RegistrationTrend = () => {
  const [days, setDays] = useState(30);

  const { query: regQuery } = useCustom<DailyCountOut[]>({
    url: 'iam/users/stats/registrations',
    method: 'get',
    config: { query: { days } },
  });

  const { query: delQuery } = useCustom<DailyCountOut[]>({
    url: 'iam/users/stats/deletions',
    method: 'get',
    config: { query: { days } },
  });

  const chartData = [
    ...(regQuery.data?.data ?? []).map((d: DailyCountOut) => ({
      ...d,
      type: REGISTRATIONS_LABEL,
    })),
    ...(delQuery.data?.data ?? []).map((d: DailyCountOut) => ({
      ...d,
      type: DELETIONS_LABEL,
    })),
  ];

  return (
    <Card
      title="Trend rejestracji"
      extra={
        <Segmented
          options={PERIODS.map((p) => ({ label: p.label, value: p.value }))}
          value={days}
          onChange={(v) => setDays(v as number)}
        />
      }
      loading={regQuery.isLoading || delQuery.isLoading}
    >
      <Area
        data={chartData}
        xField="date"
        yField="count"
        colorField="type"
        height={240}
        scale={{
          color: {
            domain: [REGISTRATIONS_LABEL, DELETIONS_LABEL],
            range: ['#1677ff', '#cf1322'],
          },
        }}
        legend={BOTTOM_LEGEND}
      />
    </Card>
  );
};
